export default __webpack_public_path__ + "static/media/DouglasLopes_01.f32e510a.jpg";